import React from 'react';
import { PageHeaderWrapper, PageTitle, BackButton } from './styles';

/**
 * PageHeader — used inside ContentContainer.
 *
 * Props:
 *   title      {string}   — page title text
 *   onBack     {function} — back action; omit to hide the button entirely
 *   backLabel  {string}   — button label (default: 'Back')
 *   autoFocus  {boolean}  — auto-focus the button on mount (TV: pre-select on page load)
 *   backFocused {boolean} — remote-navigation focus (same gold ring as channel rows)
 *   ref        {Ref}      — forwarded to the BackButton for imperative focus control
 */
const PageHeader = React.forwardRef(function PageHeader(
  { title, onBack, backLabel = 'Back', autoFocus = false, backFocused = false },
  ref
) {
  return (
    <PageHeaderWrapper>
      <PageTitle>{title}</PageTitle>
      {onBack && (
        <BackButton ref={ref} onClick={onBack} autoFocus={autoFocus} $focused={backFocused}>
          {backLabel}
        </BackButton>
      )}
    </PageHeaderWrapper>
  );
});

export default PageHeader;
